import React from 'react';
import { useRsi } from '../../hooks/useRsi';
import { Button, useBpDesignTheme, Dialog } from '@beeline.com/bp-design-system';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmCloseAlert = ({ isOpen, onClose, onConfirm }: Props) => {
  const { translations } = useRsi();
  const theme = useBpDesignTheme();

  return (
    <Dialog
      title={translations.alerts.confirmClose.headerTitle}
      subTitle={translations.alerts.confirmClose.bodyText}
      open={isOpen}
      onClose={onClose}
      id="rsi"
      show={{
        cancelButton: true
      }}
      actions={[
        <Button
          style={{ marginLeft: theme.spacingSize.l }}
          onClick={onConfirm}
          key="confirm"
          color="secondary"
          variant="contained"
        >
          {translations.alerts.confirmClose.exitButtonTitle}
        </Button>
      ]}
    />
  );
};
